import { defineComponent as p, computed as r } from "vue";
import { ExternalResourceTypes as s } from "../types/index3.js";
const f = p({
  name: "ExternalResources",
  props: {
    values: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    const e = (u) => t.values.filter((c) => c.type === u), o = r(() => e(s.Js)), n = r(function() {
      return e(s.Css);
    });
    return {
      jsResources: o,
      cssResources: n
    };
  }
});
export {
  f as default
};
//# sourceMappingURL=index6.js.map
